module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("I will not cease from Mental Fight,"), _c('br'), _vm._v("Nor shall my Sword sleep in my hand:"), _c('br'), _vm._v("Till we have built Jerusalem,"), _c('br'), _vm._v("In England’s green & pleasant Land")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("William Blake"), _c('br'), _vm._v("‘Jerusalem’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb5e5ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedi1.vue
// module id = 69
// module chunks = 0